import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [orderId, setOrderId] = useState(null);
  const pollRef = useRef(0);

  useEffect(() => {
    if (!sessionId) return;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrderId(data.order_id);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "expired" || data.payment_status === "failed") {
          setStatus("failed"); return;
        }
        if (pollRef.current < 20) {
          pollRef.current++;
          setTimeout(poll, 2000);
        } else {
          setStatus("timeout");
        }
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <main className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {status === "paid" ? (
        <>
          <CheckCircle size={64} weight="duotone" className="mx-auto text-signal mb-6"/>
          <p className="overline mb-2 text-signal">// Payment confirmed</p>
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-4">Thank you.</h1>
          <p className="font-sans text-neutral-400 mb-2">Your order has been received and is being processed.</p>
          {orderId && <p className="font-mono text-xs opacity-60 mb-8">Order ID: {orderId}</p>}
          <div className="flex gap-3 justify-center">
            <Link to="/orders" className="btn-outline-dark">View my orders</Link>
            <Link to="/" className="btn-signal">Keep shopping →</Link>
          </div>
        </>
      ) : status === "failed" ? (
        <>
          <h1 className="font-display font-black text-4xl mb-4">Payment did not complete</h1>
          <p className="font-sans text-neutral-400 mb-8">Please try again or contact support.</p>
          <Link to="/" className="btn-outline-dark">Back to shop</Link>
        </>
      ) : (
        <>
          <p className="overline opacity-60">// Verifying payment</p>
          <h1 className="font-display font-black text-4xl mt-4">One moment…</h1>
        </>
      )}
    </main>
  );
}
